import { render, staticRenderFns } from "./VuesticAlert.vue?vue&type=template&id=0548f46a&scoped=true"
import script from "./VuesticAlert.vue?vue&type=script&lang=js"
export * from "./VuesticAlert.vue?vue&type=script&lang=js"
import style0 from "./VuesticAlert.vue?vue&type=style&index=0&id=0548f46a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0548f46a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-alert/VuesticAlert.vue
// module id = EV/8
// module chunks = 41